export default __webpack_public_path__ + "static/media/analgesia_post_parto.eeee219b.pdf";